module.exports = __webpack_public_path__ + "img/corn-oil-img.7fdbb011.png";